import { Link } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalState';
import { useContext } from 'react';

export const NavConnectedUser = () => {
  const { handleLogOut, userEmail } = useContext(GlobalContext);

  return (
    <div className='nav-right'>
      <div className='current-user' title={userEmail || 'No email found'}>
        Signed in as {userEmail || 'Unknown user'}
      </div>
      <Link className='nav-item' to={'/user/mypage'}>
        Dashboard
      </Link>
      <Link className='nav-item' to={'/user/favorites'}>
        Favorites
      </Link>
      <Link
        className='nav-item'
        to={'/'}
        onClick={() => {
          handleLogOut();
        }}
      >
        Sign Out
      </Link>
    </div>
  );
};
